import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 6v12","key":"svg-0"}],["path",{"d":"M18 6l-6 6l6 6","key":"svg-1"}]]

/**
 * IconChevronLeftPipe
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hldnJvbi1sZWZ0LXBpcGUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgNnYxMiIgLz4KICA8cGF0aCBkPSJNMTggNmwtNiA2bDYgNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chevron-left-pipe
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronLeftPipe = createReactComponent('outline', 'chevron-left-pipe', 'ChevronLeftPipe', __iconNode);

export default IconChevronLeftPipe;